import { UnitRequest } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, UploadedFile, UseInterceptors } from '@nestjs/common';
import { ApiConsumes, ApiTags } from '@nestjs/swagger';
import { FileInterceptor } from '@nestjs/platform-express';
import { PurchaseOrderIdRequest } from '../po-creation/dto/po-id.request';
import { AsnItemReceivedQtyRequest } from './dto/asn-item-received-qty-request';
import { AsnIdRequest } from './dto/asn-request';
import { AsnDto } from './dto/asn.dto';
import { diskStorage } from 'multer';
import { AsnService } from './asn.service';
import { VenndorIdReq } from '../po-creation/dto/vendor-id-req';
import { AsnIdReq } from './dto/asn-id-req';
import { InvoiceCreateDto } from './dto/invoice-create-dto';
import { PaymentCreateDto } from './dto/payment-create-dto';
import { FileUploadResponse } from '@gtpl/shared-models/logistics';
import { FileUploadDto } from './dto/file-upload';
import { extname } from 'path';


@Controller('asn')
@ApiTags('asn')

export class AsnController {
    constructor(
        private asnService: AsnService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ) { }


    @Post('/createAsn')
    async createAsn(@Body() values: any): Promise<CommonResponse> {
        try {
            return this.asnService.createAsn(values);
        } catch (error) {
            return error;
        }
    }

    @Post('/getAsnListForVendor')
    async getAsnListForVendor(@Body() req: VenndorIdReq): Promise<CommonResponse> {
        try {
            return this.asnService.getAsnListForVendor(req);
        } catch (error) {
            return error;
        }
    }

    @Post('/getAsnItemsListForAsn')
    async getAsnItemsListForAsn(@Body() req: AsnIdReq): Promise<CommonResponse> {
        try {
            return this.asnService.getAsnItemsListForAsn(req);
        } catch (error) {
            return error;
        }
    }

    @Post('/getAllAsnData')
    async getAllAsnData(@Body() req: AsnIdReq): Promise<CommonResponse> {
        try {
            return this.asnService.getAllAsnData(req);
        } catch (error) {
            return error;
        }
    }

    @Post('/getAsnListforInvoice')
    async getAsnListforInvoice(@Body() req: VenndorIdReq): Promise<CommonResponse> {
        try {
            return this.asnService.getAsnListforInvoice(req);
        } catch (error) {
            return error;
        }
    }

    @Post('/getinvoiceListForVendor')
    async getinvoiceListForVendor(@Body() req: VenndorIdReq): Promise<CommonResponse> {
        try {
            return this.asnService.getinvoiceListForVendor(req);
        } catch (error) {
            return error;
        }
    }

    @Post('/createInvoice')
    async createInvoice(@Body() req: InvoiceCreateDto): Promise<CommonResponse> {
        try {
            return this.asnService.createInvoice(req);
        } catch (error) {
            console.log(error)
            return error;
        }
    }

    @Post('/getAsnListforPayment')
    async getAsnListforPayment(@Body() req: VenndorIdReq): Promise<CommonResponse> {
        try {
            return this.asnService.getAsnListforPayment(req);
        } catch (error) {
            return error;
        }
    }

    @Post('/createPayment')
    async createPayment(@Body() req: PaymentCreateDto): Promise<CommonResponse> {
        try {
            return this.asnService.createPayment(req);
        } catch (error) {
            console.log(error)
            return error;
        }
    }

    @Post('/getPoStatusReport')
    async getPoStatusReport(@Body() req: VenndorIdReq): Promise<CommonResponse> {
        try {
            return this.asnService.getPoStatusReport(req);
        } catch (error) {
            return error;
        }
    }

    @Post('/getPaymentsReport')
    async getPaymentsReport(@Body() req: VenndorIdReq): Promise<CommonResponse> {
        try {
            return this.asnService.getPaymentsReport(req);
        } catch (error) {
            return error;
        }
    }

    @Post('/getAllAsnDropdownData')
    async getAllAsnDropdownData(): Promise<CommonResponse> {
        try {
            return this.asnService.getAllAsnDropdownData();
        } catch (error) {
            return error;
        }
    }

    @Post('/acknowledgeForPo')
    async acknowledgeForPo(@Body() req: any): Promise<CommonResponse> {
        try {
            return this.asnService.acknowledgeForPo(req);
        } catch (error) {
            return error;
        }
    }

    @Post('/getPoNumbersAndPoItems')
    async getPoNumbersAndPoItems(@Body() req: any): Promise<CommonResponse> {
        try {
            return this.asnService.getPoNumbersAndPoItems(req);
        } catch (error) {
            return error;
        }
    }

    @Post('/getPoItemsForPoNumber')
    async getPoItemsForPoNumber(@Body() req: any): Promise<CommonResponse> {
        try {
            return this.asnService.getPoItemsForPoNumber(req);
        } catch (error) {
            return error;
        }
    }
    @Post('/whatsAppWebhook')
  async whatsAppWebhook(res:any) {
      try {
          return this.asnService.getMessageResponse(res);
    } catch (error) {
        return error;
    }
}
@Post('/asnFileUpload')
@ApiConsumes('multipart/form-data')
@UseInterceptors(FileInterceptor('file', {
    limits: { files: 1 },
    storage: diskStorage({
    destination: './upload-files/asn-upload-files',
    filename: (req, file, callback) => {
        const name = file.originalname.split('.')[0];
        const fileExtName = extname(file.originalname);
        const randomName = Array(4)
        .fill(null)
        .map(() => Math.round(Math.random() * 16).toString(16))
        .join('');
        callback(null, `${name}-${randomName}${fileExtName}`);
    },
    }),
    fileFilter: (req, file, callback) => {
    if (!file.originalname.match(/\.(csv|xlsx|xls|pdf|zip)$/)) {
        return callback(new Error('Only csv,xlsx,xls,pdf files are allowed!'), false);
    }
    callback(null, true);
    },
}))
async asnFileUpload(@UploadedFile() file, @Body() uploadData: FileUploadDto): Promise<FileUploadResponse> {
    console.log(file,'****')
      try {
          return await this.asnService.asnFileUpload(file.path,file.filename, uploadData.asnId);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(FileUploadResponse, error);
      }
  }

  

}
